import { Box, CircularProgress, Divider, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { getAllData } from "../../libs/firebase/firestore/getAllData";
import { useNavigateToTop } from "../../libs/useNavigateToTop";
import SiteListTable from "../../components/SiteList/Table";
import AppBarDesignerCreateSite from "../../components/AppBar/Designer/CreateSite";
import AppBarDesignerRoot from "../../components/AppBar/Designer/Root";

function ScreenDesignerSites({}) {
  const navigate = useNavigateToTop();
  // state for the site list
  const [siteList, setSiteList] = React.useState([]);

  // loading state
  const [loading, setLoading] = React.useState(true);

  useEffect(() => {
    // get the site list from firebase
    getAllData("/sites").then((data) => {
      setSiteList(data);
      setLoading(false);
    });

    // get the materials from firebase
  }, []);

  return (
    <Box>
      <AppBarDesignerRoot />

      <Box
        style={{
          padding: "2rem",
          margin: "auto 0",
        }}
      >
        {/* Title and subtitle */}
        <Typography variant="h5">Sites </Typography>
        <Typography variant="subtitle1">All the sites created</Typography>

        <Divider
          sx={{
            my: 2,
          }}
        />
        {/* loader */}
        {loading && (
          <Box
            style={{
              textAlign: "center",
              margin: "2rem 0rem",
            }}
          >
            <CircularProgress />
          </Box>
        )}
        <SiteListTable
          onClick={(site) => {
            navigate(`/designer/site/${site.storageDocumentId}`);
          }}
          // onDelete={handleOnDelete}
          data={siteList}
        />
      </Box>
    </Box>
  );
}

export default ScreenDesignerSites;
